<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @export="exportFile"
      @build="openMergeShipment"
      @checkbox-change="(rows) => (checkedRows = rows)"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            size="sm"
            variant="outline-success"
            class="ml-2"
            @click="buildBatch"
          >
            {{ $l('btn_generate_shipment') || '生成发运单' }}
            <i class="el-icon-circle-close" @click.stop="clearAllCheckbox" />
          </b-button>
        </el-badge>
      </page-header>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="templateQueryParams"
      :exportOptions="{
        params: {
          amzReplenishmentCode: chooseTemplateOptions.amzReplenishmentCode,
        },
        checkUrl: '/ecom/amz/replenishment/exportCheck',
      }"
    />

    <merge-shipment
      v-if="mergeShipmentOpts.visible"
      :visible.sync="mergeShipmentOpts.visible"
      :rows="mergeShipmentOpts.rows"
      @close="closeMergeShipment"
      @reload="reloadMergeShipment"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import MergeShipment from '../merge-shipment'
import chooseTemplate from '@/views/ecom/components/choose-template'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageHeader, PageMain, MergeShipment, chooseTemplate },
  data() {
    return {
      usePage: true,
      chooseTemplateOptions: { visible: false, amzReplenishmentCode: '' },
      mergeShipmentOpts: { visible: false, rows: [] },
      templateQueryParams: { templateGroup: 'ecom-amzReplenishmentlist' },
      checkedRows: [],
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzReplenishmentListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'ecom-awsBiz-replenishmentList-detail',
        params: { ...params, pageType },
        query,
      })
    },
    exportFile({ amzReplenishmentCode, templateGroup }) {
      console.log(templateGroup)
      this.templateQueryParams.templateGroup = templateGroup
      this.chooseTemplateOptions = { visible: true, amzReplenishmentCode }
    },
    clearAllCheckbox() {
      this.$refs.main.clearAllCheckbox()
    },
    buildBatch() {
      if (!this.checkedRowCount) {
        this.$message.warning(
          this.$l('tips_check_first') || '请先勾选要处理的记录'
        )
        return
      }
      this.openMergeShipment(this.checkedRows)
    },
    openMergeShipment(rows = []) {
      if (!rows.length) return
      this.mergeShipmentOpts = { visible: true, rows: [...rows] }
    },
    closeMergeShipment() {
      this.mergeShipmentOpts = { visible: false, rows: [] }
    },
    reloadMergeShipment() {
      this.closeMergeShipment()
      this.reload()
      this.clearAllCheckbox()
    },
  },
}
</script>

<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
